export interface IconUserModel {
  name: string
  avatar?: string
  color?: string
  initials?: string
  numbers?: number
}

export const Timezone = [
  {
    "ID": "Pacific/Midway",
    "Name": "Midway Island, Samoa"
  },
  {
    "ID": "Pacific/Pago_Pago",
    "Name": "Pago Pago"
  },
  {
    "ID": "Pacific/Honolulu",
    "Name": "Hawaii"
  },
  {
    "ID": "America/Anchorage",
    "Name": "Alaska"
  },
  {
    "ID": "America/Vancouver",
    "Name": "Vancouver"
  },
  {
    "ID": "America/Los_Angeles",
    "Name": "Pacific Time (US and Canada)"
  },
  {
    "ID": "America/Tijuana",
    "Name": "Tijuana"
  },
  {
    "ID": "America/Edmonton",
    "Name": "Edmonton"
  },
  {
    "ID": "America/Denver",
    "Name": "Mountain Time (US and Canada)"
  },
  {
    "ID": "America/Phoenix",
    "Name": "Arizona"
  },
  {
    "ID": "America/Mazatlan",
    "Name": "Mazatlan"
  },
  {
    "ID": "America/Winnipeg",
    "Name": "Winnipeg"
  },
  {
    "ID": "America/Regina",
    "Name": "Saskatchewan"
  },
  {
    "ID": "America/Chicago",
    "Name": "Central Time (US and Canada)"
  },
  {
    "ID": "America/Mexico_City",
    "Name": "Mexico City"
  },
  {
    "ID": "America/Guatemala",
    "Name": "Guatemala"
  },
  {
    "ID": "America/El_Salvador",
    "Name": "El Salvador"
  },
  {
    "ID": "America/Managua",
    "Name": "Managua"
  },
  {
    "ID": "America/Costa_Rica",
    "Name": "Costa Rica"
  },
  {
    "ID": "America/Montreal",
    "Name": "Montreal"
  },
  {
    "ID": "America/New_York",
    "Name": "Eastern Time (US and Canada)"
  },
  {
    "ID": "America/Indianapolis",
    "Name": "Indiana (East)"
  },
  {
    "ID": "America/Panama",
    "Name": "Panama"
  },
  {
    "ID": "America/Bogota",
    "Name": "Bogota"
  },
  {
    "ID": "America/Lima",
    "Name": "Lima"
  },
  {
    "ID": "America/Halifax",
    "Name": "Halifax"
  },
  {
    "ID": "America/Puerto_Rico",
    "Name": "Puerto Rico"
  },
  {
    "ID": "America/Caracas",
    "Name": "Caracas"
  },
  {
    "ID": "America/Santiago",
    "Name": "Santiago"
  },
  {
    "ID": "America/St_Johns",
    "Name": "Newfoundland and Labrador"
  },
  {
    "ID": "America/Montevideo",
    "Name": "Montevideo"
  },
  {
    "ID": "America/Araguaina",
    "Name": "Brasilia"
  },
  {
    "ID": "America/Argentina/Buenos_Aires",
    "Name": "Buenos Aires, Georgetown"
  },
  {
    "ID": "America/Godthab",
    "Name": "Greenland"
  },
  {
    "ID": "America/Sao_Paulo",
    "Name": "Sao Paulo"
  },
  {
    "ID": "Atlantic/Azores",
    "Name": "Azores"
  },
  {
    "ID": "Canada/Atlantic",
    "Name": "Atlantic Time (Canada)"
  },
  {
    "ID": "Atlantic/Cape_Verde",
    "Name": "Cape Verde Islands"
  },
  {
    "ID": "UTC",
    "Name": "Universal Time UTC"
  },
  {
    "ID": "Etc/Greenwich",
    "Name": "Greenwich Mean Time"
  },
  {
    "ID": "Europe/Belgrade",
    "Name": "Belgrade, Bratislava, Ljubljana"
  },
  {
    "ID": "CET",
    "Name": "Sarajevo, Skopje, Zagreb"
  },
  {
    "ID": "Atlantic/Reykjavik",
    "Name": "Reykjavik"
  },
  {
    "ID": "Europe/Dublin",
    "Name": "Dublin"
  },
  {
    "ID": "Europe/London",
    "Name": "London"
  },
  {
    "ID": "Europe/Lisbon",
    "Name": "Lisbon"
  },
  {
    "ID": "Africa/Casablanca",
    "Name": "Casablanca"
  },
  {
    "ID": "Africa/Nouakchott",
    "Name": "Nouakchott"
  },
  {
    "ID": "Europe/Oslo",
    "Name": "Oslo"
  },
  {
    "ID": "Europe/Copenhagen",
    "Name": "Copenhagen"
  },
  {
    "ID": "Europe/Brussels",
    "Name": "Brussels"
  },
  {
    "ID": "Europe/Berlin",
    "Name": "Amsterdam, Berlin, Rome, Stockholm, Vienna"
  },
  {
    "ID": "Europe/Helsinki",
    "Name": "Helsinki"
  },
  {
    "ID": "Europe/Amsterdam",
    "Name": "Amsterdam"
  },
  {
    "ID": "Europe/Rome",
    "Name": "Rome"
  },
  {
    "ID": "Europe/Stockholm",
    "Name": "Stockholm"
  },
  {
    "ID": "Europe/Vienna",
    "Name": "Vienna"
  },
  {
    "ID": "Europe/Luxembourg",
    "Name": "Luxembourg"
  },
  {
    "ID": "Europe/Paris",
    "Name": "Paris"
  },
  {
    "ID": "Europe/Zurich",
    "Name": "Zurich"
  },
  {
    "ID": "Europe/Madrid",
    "Name": "Madrid"
  },
  {
    "ID": "Africa/Bangui",
    "Name": "West Central Africa"
  },
  {
    "ID": "Africa/Algiers",
    "Name": "Algiers"
  },
  {
    "ID": "Africa/Tunis",
    "Name": "Tunis"
  },
  {
    "ID": "Africa/Harare",
    "Name": "Harare, Pretoria"
  },
  {
    "ID": "Africa/Nairobi",
    "Name": "Nairobi"
  },
  {
    "ID": "Europe/Warsaw",
    "Name": "Warsaw"
  },
  {
    "ID": "Europe/Prague",
    "Name": "Prague Bratislava"
  },
  {
    "ID": "Europe/Budapest",
    "Name": "Budapest"
  },
  {
    "ID": "Europe/Sofia",
    "Name": "Sofia"
  },
  {
    "ID": "Europe/Istanbul",
    "Name": "Istanbul"
  },
  {
    "ID": "Europe/Athens",
    "Name": "Athens"
  },
  {
    "ID": "Europe/Bucharest",
    "Name": "Bucharest"
  },
  {
    "ID": "Asia/Nicosia",
    "Name": "Nicosia"
  },
  {
    "ID": "Asia/Beirut",
    "Name": "Beirut"
  },
  {
    "ID": "Asia/Damascus",
    "Name": "Damascus"
  },
  {
    "ID": "Asia/Jerusalem",
    "Name": "Jerusalem"
  },
  {
    "ID": "Asia/Amman",
    "Name": "Amman"
  },
  {
    "ID": "Africa/Tripoli",
    "Name": "Tripoli"
  },
  {
    "ID": "Africa/Cairo",
    "Name": "Cairo"
  },
  {
    "ID": "Africa/Johannesburg",
    "Name": "Johannesburg"
  },
  {
    "ID": "Europe/Moscow",
    "Name": "Moscow"
  },
  {
    "ID": "Asia/Baghdad",
    "Name": "Baghdad"
  },
  {
    "ID": "Asia/Kuwait",
    "Name": "Kuwait"
  },
  {
    "ID": "Asia/Riyadh",
    "Name": "Riyadh"
  },
  {
    "ID": "Asia/Bahrain",
    "Name": "Bahrain"
  },
  {
    "ID": "Asia/Qatar",
    "Name": "Qatar"
  },
  {
    "ID": "Asia/Aden",
    "Name": "Aden"
  },
  {
    "ID": "Asia/Tehran",
    "Name": "Tehran"
  },
  {
    "ID": "Africa/Khartoum",
    "Name": "Khartoum"
  },
  {
    "ID": "Africa/Djibouti",
    "Name": "Djibouti"
  },
  {
    "ID": "Africa/Mogadishu",
    "Name": "Mogadishu"
  },
  {
    "ID": "Asia/Dubai",
    "Name": "Dubai"
  },
  {
    "ID": "Asia/Muscat",
    "Name": "Muscat"
  },
  {
    "ID": "Asia/Baku",
    "Name": "Baku, Tbilisi, Yerevan"
  },
  {
    "ID": "Asia/Kabul",
    "Name": "Kabul"
  },
  {
    "ID": "Asia/Yekaterinburg",
    "Name": "Yekaterinburg"
  },
  {
    "ID": "Asia/Tashkent",
    "Name": "Islamabad, Karachi, Tashkent"
  },
  {
    "ID": "Asia/Calcutta",
    "Name": "India"
  },
  {
    "ID": "Asia/Kathmandu",
    "Name": "Kathmandu"
  },
  {
    "ID": "Asia/Novosibirsk",
    "Name": "Novosibirsk"
  },
  {
    "ID": "Asia/Almaty",
    "Name": "Almaty"
  },
  {
    "ID": "Asia/Dacca",
    "Name": "Dacca"
  },
  {
    "ID": "Asia/Krasnoyarsk",
    "Name": "Krasnoyarsk"
  },
  {
    "ID": "Asia/Dhaka",
    "Name": "Astana, Dhaka"
  },
  {
    "ID": "Asia/Bangkok",
    "Name": "Bangkok"
  },
  {
    "ID": "Asia/Saigon",
    "Name": "Vietnam"
  },
  {
    "ID": "Asia/Jakarta",
    "Name": "Jakarta"
  },
  {
    "ID": "Asia/Irkutsk",
    "Name": "Irkutsk, Ulaanbaatar"
  },
  {
    "ID": "Asia/Shanghai",
    "Name": "Beijing, Shanghai"
  },
  {
    "ID": "Asia/Hong_Kong",
    "Name": "Hong Kong"
  },
  {
    "ID": "Asia/Taipei",
    "Name": "Taipei"
  },
  {
    "ID": "Asia/Kuala_Lumpur",
    "Name": "Kuala Lumpur"
  },
  {
    "ID": "Asia/Singapore",
    "Name": "Singapore"
  },
  {
    "ID": "Australia/Perth",
    "Name": "Perth"
  },
  {
    "ID": "Asia/Yakutsk",
    "Name": "Yakutsk"
  },
  {
    "ID": "Asia/Seoul",
    "Name": "Seoul"
  },
  {
    "ID": "Asia/Tokyo",
    "Name": "Osaka, Sapporo, Tokyo"
  },
  {
    "ID": "Australia/Darwin",
    "Name": "Darwin"
  },
  {
    "ID": "Australia/Adelaide",
    "Name": "Adelaide"
  },
  {
    "ID": "Asia/Vladivostok",
    "Name": "Vladivostok"
  },
  {
    "ID": "Pacific/Port_Moresby",
    "Name": "Guam, Port Moresby"
  },
  {
    "ID": "Australia/Brisbane",
    "Name": "Brisbane"
  },
  {
    "ID": "Australia/Sydney",
    "Name": "Canberra, Melbourne, Sydney"
  },
  {
    "ID": "Australia/Hobart",
    "Name": "Hobart"
  },
  {
    "ID": "Asia/Magadan",
    "Name": "Magadan"
  },
  {
    "ID": "SST",
    "Name": "Solomon Islands"
  },
  {
    "ID": "Pacific/Noumea",
    "Name": "New Caledonia"
  },
  {
    "ID": "Asia/Kamchatka",
    "Name": "Kamchatka"
  },
  {
    "ID": "Pacific/Fiji",
    "Name": "Fiji Islands, Marshall Islands"
  },
  {
    "ID": "Pacific/Auckland",
    "Name": "Auckland, Wellington"
  },
  {
    "ID": "Asia/Kolkata",
    "Name": "Mumbai, Kolkata, New Delhi"
  },
  {
    "ID": "Europe/Kiev",
    "Name": "Kiev"
  },
  {
    "ID": "America/Tegucigalpa",
    "Name": "Tegucigalpa"
  },
  {
    "ID": "Pacific/Apia",
    "Name": "Independent State of Samoa"
  }
 ]